var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pt-3 page-container px-0",attrs:{"id":"ahs-new-request"}},[_c(_vm.conditionalComponent,{tag:"component",staticClass:"mt-3",attrs:{"mode":"new"},on:{"onSave":_vm.onSave,"cancelCreation":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }